/**
 * 根据当前浏览器的协议替换传入地址的协议
 * @param {string} url
 * @returns {string}
 */
export default function switchProtocol(url) {
  if (typeof url !== 'string') return url

  let currentProtocol = window.location.protocol;
  if (currentProtocol === "https:") {
    if (url.indexOf("https:") === 0) return url;

    return url.replace("http:", "https:");
  } else {
    if (url.indexOf("http:") === 0) return url;

    return url.replace("https:", "http:");
  }
}
